import React, { useState, useEffect, useCallback } from "react";
import "./ManageDashboardScreen2.scss";
import logo from "../../../assets/images/SimpleRenovate.svg";
import sidebarImg1 from "../../../assets/img/sidebar img 1.svg";
import sidebarImg2 from "../../../assets/img/sidebar img 2.svg";
import sidebarImg3 from "../../../assets/img/sidebar img 3.svg";
import sidebarImg4 from "../../../assets/img/sidebar img 4.svg";
import logoutIcon from "../../../assets/img/sidebar logout.svg";
import SimpleRenovate2PNG from "../../../assets/img/SimpleRenovate2PNG 5.svg";
import togglerIcon from "../../../assets/img/toggler.svg";
import dashboardCard1 from "../../../assets/img/dashboard card 1.svg";
import dashboardCard2 from "../../../assets/img/dashboard card 2.svg";
import dashboardCard3 from "../../../assets/img/dashboard card 3.svg";
import dashboardStar from "../../../assets/img/dashboard star.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import {
  getMobileRedirectionAuthToken,
  syncMobileRedirectionSession,
} from "../../../Helper/mobileAuth";
import Loader from "../../Loader/Loader";

const ManageDashboardScreen2 = ({ onClose }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [founderOfferEnabled, setFounderOfferEnabled] = useState(false);

  const applyProfileToUi = useCallback((profile) => {
    if (!profile) {
      return;
    }
    setUserName(profile.firstName || profile.name || "");
    setIsSubscribed(profile.isSubscribed === 1);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadProfessionalProfile = async () => {
      const token = getMobileRedirectionAuthToken();
      if (!token) {
        navigation("/login", { replace: true });
        return;
      }

      setLoading(true);

      try {
        const [profileResponse, settingsResponse] = await Promise.all([
          dispatch(hitGetProfileApi(token)),
          dispatch(hitGetSettingsApi()),
        ]);

        if (!isMounted) {
          return;
        }

        if (settingsResponse?.payload?.status === true && settingsResponse.payload.data) {
          setFounderOfferEnabled(
            Number(settingsResponse.payload.data.isProFounderOfferOnOff) === 1
          );
        }

        if (profileResponse?.payload?.status === true && profileResponse.payload.data) {
          const profile = profileResponse.payload.data;
          syncMobileRedirectionSession(profile);
          applyProfileToUi(profile);
        } else {
          const cached = localStorage.getItem("mobileRedirectionProData");
          if (cached) {
            try {
              applyProfileToUi(JSON.parse(cached));
            } catch {
              /* use empty UI state */
            }
          }
        }
      } catch {
        // 401: global axios interceptor clears storage, shows alert, redirects to /login
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadProfessionalProfile();

    return () => {
      isMounted = false;
    };
  }, [dispatch, navigation, applyProfileToUi]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClose = () => {
    setIsMenuOpen(false);
    if (onClose) onClose();
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const menuOptions = [
    {
      id: 1,
      icon: <img src={dashboardCard1} alt="Subscription Icon" />,
      title: "Manage Subscription",
      navigation: "/manage-subscription",
      description:
        "View and update your current plan, billing cycle, and payment methods",
    },
    {
      id: 2,
      icon: <img src={dashboardCard2} alt="Credits Icon" />,
      title: "Manage Credits",
      navigation: "/manage-credits",
      description:
        "Check your credit balance and purchase additional credits for services",
    },
    {
      id: 3,
      icon: <img src={dashboardCard3} alt="Service Area Icon" />,

      title: "Manage Service Areas",
      navigation: "/manage-service-area",
      description:
        "Update your service locations and coverage areas for your business",
    },
  ];

  const menuItems = [
    {
      id: "subscription",
      icon: <img src={sidebarImg1} alt="Subscription Icon" />,
      title: "Manage Subscription",
      description: "View and update your plan",
      onClick: () => { setActiveMenuItem("subscription"); navigation("/manage-subscription"); },
    },
    {
      id: "credits",
      icon: <img src={sidebarImg2} alt="Credits Icon" />,
      title: "Manage Credits",
      description: "Check and purchase credits",
      onClick: () => { setActiveMenuItem("credits"); navigation("/manage-credits"); },
    },
    {
      id: "service-area",
      icon: <img src={sidebarImg3} alt="Service Area Icon" />,
      title: "Manage Service Areas",
      description: "Update service locations",
      onClick: () => { setActiveMenuItem("service-area"); navigation("/service-area"); },
    },
    // {
    //   id: "pro-plan",
    //   icon: <img src={sidebarImg4} alt="Pro Plan Icon" />,
    //   title: "Buy Pro Plan",
    //   description: "Unlock premium features",
    //   onClick: () => setActiveMenuItem("pro-plan"),
    //   highlighted: true,
    // },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigation("/login", { replace: true });
  };

  const [activeMenuItem, setActiveMenuItem] = useState("subscription");

  if (loading) {
    return (
      <div style={{ minHeight: "60vh" }}>
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className="welcome-dashboard manage-dashboard-screen-2 mb-5">
        <div className="custom_container">
          {/* <div className="d-flex justify-content-between align-center mb-4">
            <img
              src={SimpleRenovate2PNG}
              alt="Logo"
              className="welcome-dashboard__logo"
            />
            <img
              src={togglerIcon}
              alt="Menu Toggle"
              className="welcome-dashboard__logo"
              onClick={toggleMenu}
              style={{ cursor: "pointer" }}
            />
          </div> */}
          <div className="dashboard-container">
            <header className="dashboard-header">
              <h1 className="welcome-title">
                Welcome, <span>{userName}!</span>
              </h1>
              <p className="welcome-subtitle">
                Manage your subscription, credits, service areas, and upgrade to
                the Pro Plan easily from here.
              </p>
            </header>

            {founderOfferEnabled && isSubscribed === false ? (
              <div className="offer-section">
                <div className="offer-badge">
                  <img src={dashboardStar} alt="star" />
                  LIMITED TIME OFFER
                </div>

                <div className="offer-content">
                  <h2 className="offer-title">Claim Your Founding Offer Now</h2>
                  <p className="offer-description">
                    Join as a founding member and unlock exclusive benefits. Only
                    a few spots remaining!
                  </p>
                  <button className="offer-cta" onClick={() => { handleViewDetails(); navigation("/buy-pro-plan"); }}>Claim Offer Now</button>
                </div>
              </div>
            ) : null}

            <div className="options-section">
              <p className="options-label">
                Select an option below to get started
              </p>
              <div className="options-grid">
                {menuOptions.map((option, index) => (
                  <div
                    key={option.id}
                    className="option-card"
                    style={{ animationDelay: `${index * 0.1}s` }}
                    onClick={() => { handleViewDetails(); navigation(option.navigation); }}
                  >
                    <div className="option-icon">{option.icon}</div>
                    <h3 className="option-title">{option.title}</h3>
                    <p className="option-description">{option.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={`account-menu ${isMenuOpen ? "account-menu--open" : ""}`}
          >
            <div className="account-menu__header">
              <div className="account-menu__logo">
                <img src={logo} alt="Logo" />
              </div>
              <button className="account-menu__close" onClick={handleClose}>
                ✕
              </button>
            </div>

            {/* <div className="account-menu__content">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  className={`menu-item ${activeMenuItem === item.id ? "menu-item--highlighted" : ""}`}
                  onClick={item.onClick}
                >
                  <div className="menu-item__icon">{item.icon}</div>
                  <div className="menu-item__content">
                    <div className="menu-item__title">{item.title}</div>
                    <div className="menu-item__description">
                      {item.description}
                    </div>
                  </div>
                </button>
              ))}
            </div> */}
            {/* 
            <div className="account-menu__footer">
              <button className="logout-button" onClick={handleLogout}>
                <img
                  src={logoutIcon}
                  alt="Logout Icon"
                  className="logout-button__icon"
                />
                <span className="logout-button__text">Logout</span>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageDashboardScreen2;
